/**
 * Selector de un filtro con opcion "todos".
 *
 * Solo deja elegir valores del catalogo (`lib/catalogs.ts`), que a su vez esta
 * atado a los tipos de `@amoble/contracts`: la UI no puede inventar un estado o
 * un sistema que el backend no conoce.
 */
import type { ReactElement } from 'react';
import type { Option } from '../lib/catalogs';

export interface SelectFilterProps<T extends string> {
  readonly label: string;
  readonly value: T | null;
  readonly options: readonly Option<T>[];
  /** Texto de la opcion vacia. Por defecto "Todos". */
  readonly allLabel?: string;
  readonly onChange: (value: T | null) => void;
}

export function SelectFilter<T extends string>({
  label,
  value,
  options,
  allLabel,
  onChange,
}: SelectFilterProps<T>): ReactElement {
  return (
    <label className="field">
      <span className="field__label">{label}</span>
      <select
        className="select"
        value={value ?? ''}
        onChange={(event) => {
          const raw = event.target.value;
          const found = options.find((option) => option.value === raw);
          onChange(found ? found.value : null);
        }}
      >
        <option value="">{allLabel ?? 'Todos'}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
